import React from 'react';
import {observer} from 'mobx-react';
import {HorizontalArrowsMenuBar} from "../../../core/components/horizontal-arrows-menu-bar/components/horizontal-arrows-menu-bar";
import {StandingsWidgetStageViewModel} from "../models/standings-widget.stage.view-model";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import styles from "../styles/standings-widget.module.scss";
import classnames from "classnames";
import {StandingsWidgetMenuItem} from "./standings-widget.menu-item";

export const StandingsWidgetStages = observer(({controller}) => {
  const {state, device} = controller;
  const {isSmallView, isRtl} = device;
  const {shouldRenderStagesHorizontalMenu, stagesWithStandings, currentStage} = state;

  const menuBarProps = {
    isRtl,
    items: stagesWithStandings,
    selectedItem: currentStage,
    additionalClassName: classnames(styles.horizontal_bar,{[styles.small_view]: isSmallView}),
    activeClassName: classnames(styles.active),
    contentId: currentStage?.competitionId,
    height: STANDINGS_WIDGET.MENU_BAR_HEIGHT,
    ItemComponent: StandingsWidgetMenuItem,
    onItemChange: (stage: StandingsWidgetStageViewModel) =>
      controller.action(STANDINGS_WIDGET.ACTION_TYPES.onStageChange, {stage}),
  }

  return (
    shouldRenderStagesHorizontalMenu ? <HorizontalArrowsMenuBar {...menuBarProps}/> : null
  )
});
